import { takeLeading, put, all, call } from 'redux-saga/effects';
import HomeActionTypes from './home.types';
import {
    homeSyncFinish
} from './home.actions';
import { log } from '../../helpers/core.helper';

export function* getHomeData({ payload }) {
    try {

        let initialSynced = true;
        let syncinghome = true;
        let message = "success";

        yield put(homeSyncFinish({ initialSynced, syncinghome, message }));

    } catch (err) {
        log('home.sagas', 'getBannerData', err);
        yield put(homeSyncFinish({ initialSynced: false, syncinghome: false, message: err }));
    }
}



export function* homeSyncStart() {
    yield takeLeading(
        HomeActionTypes.HOME_SYNC_START,
        getHomeData
    )
}
/** 
 * Initialise all local sagas
 */
export function* homeSagas() {
    yield all([
        call(homeSyncStart),
    ])
}